import { FC } from 'react';
import clsx from 'clsx';
import styles from './SelectOption.css';
import { Checkbox, TooltipDesktop, UIText2, UIText3 } from '@cian/ui-kit';
import { IconFunctionalInformation16 } from '@cian/ui-kit-design-tokens/icons';
import { preventDefault } from 'shared/utils/event';
import { TSelectOptionValue } from 'shared/types/filters';

interface ISelectOptionProps {
  value: TSelectOptionValue;
  label: string;
  marker?: string;
  description?: string;
  index: number;
  selected: boolean;
  withDivider?: boolean;
  onClick(e: React.MouseEvent<HTMLDivElement>): void;
}

export const SelectOption: FC<ISelectOptionProps> = ({
  selected,
  label,
  marker,
  description,
  withDivider,
  onClick,
}) => {
  return (
    <div className={clsx(styles['option'], withDivider && styles['option-with-divider'])} onClick={onClick}>
      <div className={styles['checkbox']}>
        <Checkbox checked={selected} onClick={preventDefault} />
      </div>

      {label}

      {marker && (
        <span className={styles['marker']}>
          <UIText3 fontWeight="bold" color="text-inverted-default">
            {marker}
          </UIText3>
        </span>
      )}

      {description && (
        <span className={styles['info']} onClick={preventDefault}>
          <TooltipDesktop
            placement="top-end"
            title={
              <div className={styles['tooltip-content']}>
                <UIText2 color="white_100" textAlign="left">
                  {description}
                </UIText2>
              </div>
            }
          >
            <span className={styles['info-badge']}>
              <IconFunctionalInformation16 color="icon-main-default" />
            </span>
          </TooltipDesktop>
        </span>
      )}
    </div>
  );
};
